'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = combinePath;
/**
 * 合并父路由与子路由，形成新的路由
 *
 * @param start
 * @param end
 * @returns {string}
 */
function combinePath() {
    var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
    var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';

    var newEnd = end.indexOf('/') === 0 ? end.slice(1) : end;
    var newStart = start.lastIndexOf('/') === start.length - 1 ? start : start + '/';
    return '' + newStart + newEnd;
}